<template>
  <div class="mt-s">
    <div class="mb-5 w-full">
      <fieldset>
        <div class="form-group">
          <input
            v-model="searchQuery"
            type="search"
            class="form-control form-search"
            placeholder="Type to find what you are looking for"
            aria-controls="datatables"
            autofocus
          />
        </div>
      </fieldset>
    </div>

    <div>
      <el-table
        class="table-striped"
        :data="queriedData"
        :default-sort="defaultSort"
        border
        style="width: 100%"
      >
        <el-table-column
          sortable
          :sort-orders="['ascending', 'descending']"
          min-width="250"
          prop="fullName"
          label="Name"
        >
          <template #default="scope">
            <div class="flex">
              <div class="mr-3">
                <router-link
                  :to="{
                    name: 'companies_users@show',
                    params: { id: scope.row.id },
                    query: { tab: scope.row.tab },
                  }"
                >
                  {{ scope.row.fullName }}
                </router-link>
              </div>
              <div v-if="scope.row.settings.suspend.status">
                <Icon :type="'suspend'" class="text-info" />
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          sortable
          :sort-orders="['ascending', 'descending']"
          :min-width="column.minWidth"
          :prop="column.prop"
          :label="column.label"
        />
      </el-table>
    </div>

    <!-- <div class="flex justify-between items-center">
          <div>
            <p class="category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>

          <p-pagination
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
          />

          <div>
            <el-select
              v-model="pagination.perPage"
              class="select-default"
              placeholder="Per page"
            >
              <el-option
                v-for="item in pagination.perPageOptions"
                :key="item"
                class="select-default"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </div> -->
  </div>
</template>
<script>
import tableConfig from "@providers/table";
import Icon from "@components/UIComponents/TopicIcon/Icon";

export default {
  components: {
    Icon,
  },
  props: {
    propList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableColumns: [
        // {
        //   prop: "companyRpes",
        //   label: "Registry, Purpose, Equipment",
        //   minWidth: 300
        // },
        // {
        //   prop: "companyRoles",
        //   label: "Role(s)",
        //   minWidth: 180
        // },
        {
          prop: "type",
          label: "Type(s)",
          minWidth: 180,
        },
      ],
      ...tableConfig.data,
      defaultSort: { prop: "fullName", order: "ascending" },
    };
  },
  computed: {
    ...tableConfig.computed,
    tableData() {
      return this.propList;
    },
  },
  async mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
